import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import Branches from "./pages/Branches";
import Agents from "./pages/Agents";
import Webhooks from "./pages/Webhooks";
import Callyzer from "./pages/Callyzer";
import Kraya from "./pages/Kraya";
import Reports from "./pages/Reports";
import Sources from "./pages/Sources";
import Security from "./pages/Security";
import BranchRouting from "./pages/BranchRouting";
import Permissions from "./pages/Permissions";
import Campaigns from "./pages/Campaigns";
import Businesses from "./pages/Businesses";
import Conversions from "./pages/Conversions";
import MyDay from "./pages/MyDay";
import Duplicates from "./pages/Duplicates";
import AppLayout from "./components/AppLayout";
import { Toaster } from "./components/ui/sonner";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center text-xs uppercase tracking-[0.2em] text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route
              path="/"
              element={
                <Protected>
                  <AppLayout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="my-day" element={<MyDay />} />
              <Route path="leads" element={<Leads />} />
              <Route path="duplicates" element={<Duplicates />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="callyzer" element={<Callyzer />} />
              <Route path="kraya" element={<Kraya />} />
              <Route path="reports" element={<Reports />} />
              <Route path="sources" element={<Sources />} />
              <Route path="branches" element={<Branches />} />
              <Route path="agents" element={<Agents />} />
              <Route path="security" element={<Security />} />
              <Route path="routing" element={<BranchRouting />} />
              <Route path="permissions" element={<Permissions />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="conversions" element={<Conversions />} />
              <Route path="businesses" element={<Businesses />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
